import { memo, useContext } from "react";
import SoftBox from "components/SoftBox";
import KeyValueInputs from "./KeyValueInputs";
import { form } from "../schemas/form";
import ResponseCode from "./ResponseCode";
import AddOptionsInput from "./AddOptionsInput";
import AllowedOrigins from "./AllowedOrigins";
import PayloadContentTypeInputs from "./PayloadContentTypeInputs";
import { FormFieldsContext } from "layouts/Flow Designer/context";
import StyledDivider from "./StyledDivider";

const AdditionalOptions = ({ allowEditWorkflow }) => {
  const { responseHeaders, responseCode, payloadContentType, allowedOrigins } =
    form.formField;
  const formRef = useContext(FormFieldsContext);

  return (
    <SoftBox>
      <StyledDivider />
      {formRef?.values?.additionalOptions.includes(allowedOrigins.name) && (
        <AllowedOrigins allowEditWorkflow={allowEditWorkflow} />
      )}
      {formRef?.values?.additionalOptions.includes(responseCode.name) && (
        <ResponseCode allowEditWorkflow={allowEditWorkflow} />
      )}
      {formRef?.values?.additionalOptions.includes(responseHeaders.name) && (
        <KeyValueInputs
          field={responseHeaders}
          fieldName="responseHeaders"
          buttonTitle="Add Response Header"
          allowEditWorkflow={allowEditWorkflow}
        />
      )}
      {formRef?.values?.additionalOptions.includes(payloadContentType.name) && (
        <PayloadContentTypeInputs allowEditWorkflow={allowEditWorkflow} />
      )}
      <AddOptionsInput allowEditWorkflow={allowEditWorkflow} />
    </SoftBox>
  );
};

export default memo(AdditionalOptions);
